module.exports = __webpack_public_path__ + "img/1729216504170-WhatsApp Image 2024-10-18 at 09.51.02.jpeg.e0982e6e.webp";